import { DocumentNode } from '@apollo/client/core';

export enum DataListQueryParams {
  filters = 'filters',
  sort = 'sort',
  archived = 'archived',
  unarchive = 'unarchive'
}

export interface DataListConfig {
  dataDocument: DocumentNode;
  dataAccessKey: string;
  statsDocument?: DocumentNode;
  statsAccessKey?: string;
  skipLoader?: boolean;
}

export interface DataListBaseOptions {
  withArchive: boolean;
  withSendEmail: boolean;
  withPlainDeleteConfirm?: boolean;
  withDuplicating?: boolean;
  withNestedEntitiesDelete?: boolean;
  withDownload?: boolean;
  hideEdit?: boolean;
  withOpen?: boolean;
  withChangeVisibility?: boolean;
  withSync?: boolean;
  withDisabledSync?: boolean;
}
